module.exports = __webpack_public_path__ + "img/pr-11.c2b4466f.png";